import Vue from "vue";
export default {
  GET_ALL(state, payload) {
    state.getAllBanner = payload;
  },
  SELECTED_BANNER(state, payload) {
    state.selectedBanner = payload;
  },
  GET_MASTER_CAMPAIGN(state, payload) {
    state.getMasterCampaign = payload;
  },
  GET_PARTNER(state, payload) {
    state.campaignPartner = payload;
  },
  GET_CAMPAIGN_HOME(state, payload) {
    state.campaignHome = payload;
  },
  SELECT_CAMPAIGN_HOME(state, payload) {
    state.selectedcampaignHome = payload;
  },
  GET_ABOUT_CAMPAIGN_BANNER(state, payload) {
    state.aboutcampaignBanner = payload;
  },
  SELECT_ABOUT_CAMPAIGN_BANNER(state, payload) {
    state.selectedcampaignBanner = payload;
  },
  GET_CAMPAIGN_REFERENCE(state, payload) {
    state.campaignReference = payload;
  },
  SELECT_CAMPAIGN_REFERENCE(state, payload) {
    state.selectedcampaignReference = payload;
  },

  SELECT_PARTNER(state, payload) {
    state.selectedPartner = payload;
  },
};
